module.exports = __webpack_public_path__ + "static/media/profile.344051ab.png";